import { Card, Typography, Divider, Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import DriverPersonalDetails from "./AddNewDriverTabs/DriverPersonalDetails";
import DriverBankDetail from "./AddNewDriverTabs/DriverBankDetail";
import { jwtDecode } from "jwt-decode";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";
import { useEffect } from "react";

const AddNewDriver = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage Driver", permissionJson, "edit")) {
        navigate("/manage-driver");
      }
    } else {
      if (!checkPermissionAction("Manage Driver", permissionJson, "add")) {
        navigate("/manage-driver");
      }
    }
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            {id ? "Edit" : "Add New"} Driver
          </Typography>
          <p className="ml-[26px]">Create a brand new user and add them to the site</p>
        </div>
        <Divider />
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={"Personal details"} key={1}>
            <DriverPersonalDetails />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Bank detail"} key={2}>
            <DriverBankDetail />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab={"Working hours"} key={2}>
            <WorkingHours />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Holidays"} key={3}>
            <Holidays />
          </Tabs.TabPane> */}
        </Tabs>
        <Divider />
      </Card>
    </>
  );
};
export default AddNewDriver;
